import { memo } from 'react';
export default memo(function NewClientBookingInfo({
  ...props
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: "c-booking-auth__title"
  }, "Nouveau client"), /*#__PURE__*/React.createElement("p", {
    className: "c-booking-auth__txt"
  }, "L'inscription n'est pas obligatoire pour r\xE9server. L'espace myWO est con\xE7u pour que vous puissiez retrouver facilement toutes vos r\xE9servations."));
});
